import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storage } from '@/configs/storage';
import {
  DEFAULT_MEINE_REGION_RADIUS_KM,
  MEINE_REGION_MAX_KM,
  MEINE_REGION_MIN_KM,
  REGIONALFUNK_RADIUS_STORE_KEY
} from '@/features/geo-area/constants/radius';

export type RegionalfunkRadiusStore = {
  meineRegionRadiusKm: number;
  setMeineRegionRadiusKm: (km: number) => void;
};

const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max);

export const useRegionalfunkRadiusStore = create<RegionalfunkRadiusStore>()(
  persist(
    (set) => ({
      meineRegionRadiusKm: DEFAULT_MEINE_REGION_RADIUS_KM,
      setMeineRegionRadiusKm: (km) =>
        set({
          meineRegionRadiusKm: clamp(
            Math.round(km),
            MEINE_REGION_MIN_KM,
            MEINE_REGION_MAX_KM
          )
        })
    }),
    {
      name: REGIONALFUNK_RADIUS_STORE_KEY,
      storage: createJSONStorage(() => storage)
    }
  )
);
